/* eslint-disable no-param-reassign */
import { Action } from 'overmind';

export const setSideNavCollapsed: Action<boolean> = ({ state }, collapsed: boolean) => {
  state.sideColapsed = collapsed;
};
